import { environment } from "./../../../../config/local.config.js";

export const featureToggle = (key: 'batRequestFlowEnabled' | string, fallback = false) => {
    if (!environment) return fallback;

    const features = environment.features ?? {};

    return Object.keys(features).includes(key) ? features[key] : fallback;
};
